export enum ApplicationStatus {
   Draft = 1,
   Submitted = 2,
   Returned = 3,
   Resubmitted = 4,
   InCompliance = 5,
   NonCompliance = 6,
   PositiveReview = 7,
   NegativeReview = 8,
   Approved = 9,
   Rejected = 10
}